import { EMAIL_SEPARATOR, NOTIFY_ME_VARIANTS } from './constants';
export const putEmailIntoMessage = (message, emailText) => {
    const splitedText = message.split(EMAIL_SEPARATOR);
    return [
        splitedText[0],
        `<span style='font-weight: 500;'>${emailText}</span>`,
        splitedText[1],
    ].join('');
};
export const getNotifyMeAlertMessage = (notifyType, notifyMeLabels, productNotifyMeDisclaimer = '') => {
    if (notifyType === NOTIFY_ME_VARIANTS.backInStock) {
        return notifyMeLabels.notifyMeVariantNotAvailableMessage;
    }
    if (notifyType === NOTIFY_ME_VARIANTS.productReleaseAnnouncement) {
        return productNotifyMeDisclaimer || notifyMeLabels.notifyMeKeepMeInformedMessage;
    }
    return '';
};
export const getResponseText = (notifyType, notifyMeLabels) => {
    if (notifyType === NOTIFY_ME_VARIANTS.backInStock) {
        return {
            successLabelText: notifyMeLabels.notifyMeEmailReceivedMessage,
            title: notifyMeLabels.notifyMeBackInStockHeader,
        };
    }
    if (notifyType === NOTIFY_ME_VARIANTS.productReleaseAnnouncement) {
        return {
            successLabelText: notifyMeLabels.notifyMeProductAnnouncementEmailReceivedMessage,
            title: notifyMeLabels.commonSuccessLabel,
        };
    }
    return {
        successLabelText: '',
        title: '',
    };
};
export function getNotifyMeLabels(labels) {
    const { notifyMe_emailReceived_message: notifyMeEmailReceivedMessage = '', notifyMe_getNotified_link: notifyMeGetNotifiedLink = '', notifyMe_gotIt_button: notifyMeGotItButton = '', notifyMe_invalidEmailFormat_error: notifyMeInvalidEmailFormatError = '', notifyMe_notifyMeBackInStock_header: notifyMeBackInStockHeader = '', notifyMe_notifyMe_button: notifyMeButton = '', notifyMe_stopKeepingEmailMessage_message: notifyMeStopKeepingEmailMessage = '', notifyMe_variantNotAvailable_message: notifyMeVariantNotAvailableMessage = '', notifyMe_enterYourEmail_placeholder: notifyMeEnterYourEmail = '', common_cancel_button: commonCancelButton = '', common_somethingWentWrong_message: commonSomethingWentWrong = '', common_email_label: commonEmailLabel = '', common_firstName_label: commonFirstNameLabel = '', common_lastName_label: commonLastNameLabel = '', common_phoneNumber_label: commonPhoneNumberLabel = '', common_success_label: commonSuccessLabel = '', common_error_label: commonErrorLabel = '', common_countryNameOrCode_label: commonCountryNameOrCodeLabel = '', notifyMe_keepMeInformed_message: notifyMeKeepMeInformedMessage = '', notifyMe_getNotifiedAboutProduct_label: notifyMeGetNotifiedAboutProductLabel = '', notifyMe_keepMeInformedTitle_description: notifyMeKeepMeInformedTitleDescription = '', notifyMe_enterYourFirstName_placeholder: notifyMeEnterYourFirstNamePlaceholder = '', notifyMe_enterYourLastName_placeholder: notifyMeEnterYourLastNamePlaceholder = '', notifyMe_enterYourPhoneNumber_placeholder: notifyMeEnterYourPhoneNumberPlaceholder = '', notifyMe_pleaseFillInField_error: notifyMePleaseFillInFieldError = '', notifyMe_productAnnouncementEmailReceived_message: notifyMeProductAnnouncementEmailReceivedMessage = '', } = labels;
    return {
        notifyMeKeepMeInformedMessage,
        notifyMeGetNotifiedAboutProductLabel,
        notifyMeKeepMeInformedTitleDescription,
        notifyMeEnterYourFirstNamePlaceholder,
        notifyMeEnterYourLastNamePlaceholder,
        notifyMePleaseFillInFieldError,
        notifyMeProductAnnouncementEmailReceivedMessage,
        notifyMeEmailReceivedMessage,
        notifyMeGetNotifiedLink,
        notifyMeGotItButton,
        notifyMeInvalidEmailFormatError,
        notifyMeBackInStockHeader,
        notifyMeButton,
        notifyMeStopKeepingEmailMessage,
        notifyMeEnterYourEmail,
        notifyMeVariantNotAvailableMessage,
        notifyMeEnterYourPhoneNumberPlaceholder,
        commonCancelButton,
        commonSomethingWentWrong,
        commonEmailLabel,
        commonFirstNameLabel,
        commonLastNameLabel,
        commonPhoneNumberLabel,
        commonSuccessLabel,
        commonErrorLabel,
        commonCountryNameOrCodeLabel,
    };
}
